import { render } from "./CompaniesPage.vue?vue&type=template&id=4c2d4b30&scoped=true"
import script from "./CompaniesPage.vue?vue&type=script&lang=js"
export * from "./CompaniesPage.vue?vue&type=script&lang=js"

import "./CompaniesPage.vue?vue&type=style&index=0&id=4c2d4b30&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2d4b30"]])

export default __exports__